import React from "react";
import "../assets/styles/components/Arguments.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faMapMarkerAlt, faHandsHelping } from "@fortawesome/free-solid-svg-icons";

const Arguments = () => {
  const argumentsList = [
    {
      icon: <FontAwesomeIcon icon={faBuilding} />,
      title: "Flexibilité <br>au Quotidien",
      description:
        "Avec ACG VO, vous bénéficiez d'une flexibilité totale pour vos besoins professionnels. Que vous ayez besoin d'un bureau privé, d'un espace de coworking ou d'une salle de réunion, nous nous adaptons à vos exigences spécifiques pour vous offrir un environnement de travail optimal à Villiers-Le-Bel.",
    },
    {
      icon: <FontAwesomeIcon icon={faMapMarkerAlt} />,
      title: "Emplacement<br>Stratégique",
      description:
        "Situé à Villiers-Le-Bel, dans le Val d'Oise, ACG VO offre un emplacement facilement accessible, idéal pour vos équipes et vos clients. Profitez de la proximité avec les grands axes de transport, d'un cadre professionnel stimulant pour vos affaires, ainsi que d'une offre variée de restauration à proximité pour répondre à vos besoins durant vos journées de travail.",
    },
    {
      icon: <FontAwesomeIcon icon={faHandsHelping} />,
      title: "Services<br>Personnalisés",
      description:
        "Nous nous engageons à fournir des services personnalisés pour répondre à vos besoins uniques. De la gestion de votre courrier à la domiciliation de votre entreprise, en passant par l'organisation d'événements professionnels, notre équipe dévouée est là pour soutenir votre succès et faciliter votre quotidien professionnel.",
    },
  ];

  return (
    <section id="arguments" className="py-5">
      <div className="container text-center">
        <h2 className="mb-5">ACG-VO, VOTRE CHOIX STRATÉGIQUE</h2>
        <div className="row">
          {argumentsList.map((item, index) => (
            <div key={index} className="col-md-4">
              <div className="argument-item">
                <div className="argument-icon">{item.icon}</div>
                <h3 className="argument-title" dangerouslySetInnerHTML={{ __html: item.title }}></h3>
                <p className="argument-description">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Arguments;
